import isNil from 'lodash/isNil';

export const sanitizeContext = (
  context: Record<string, unknown>,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(context).filter(([, value]): boolean => !isNil(value)),
  );
